module.exports = __webpack_public_path__ + "img/108.68801729.jpg";